import { Fragment } from "react"
import PropTypes from "prop-types"
import { Link } from "@reach/router"
import { Box, Button, StackView } from "@planningcenter/tapestry-react"

const SectionHeading = ({
  headerText,
  headerSubText,
  headerActions = [],
  className,
  style,
  children,
  childrenClassName,
  headerTextStyle
}) => {
  const renderHeaderAction = action => {
    const navButton = action && (
      <Button
        title={action.title}
        icon={action.icon || null}
        tooltip={action.tooltip || null}
        variant={action.variant || "outline"}
        size={action.size || "xs"}
        className={action.className}
        style={action.style || {}}
        as={action.to ? Link : action.as || "button"}
        onClick={action.onClick || null}
        type={action.type || null}
        theme={action.theme || "default"}
        to={action.to || null}
      />
    )

    return <Fragment key={action.title}>{navButton}</Fragment>
  }

  return (
    <header className={className} style={style}>
      <StackView
        axis="horizontal"
        alignment="center"
        distribution="space-between"
        spacing={1}
        shrink={1}
      >
        <Box width="100%">
          <StackView axis="horizontal" alignment="center" spacing={1}>
            <h1 className="h2 mb-0" style={headerTextStyle}>
              {headerText}
            </h1>
            {headerActions.map(action => renderHeaderAction(action))}
          </StackView>
          {headerSubText && <h2 className="font-size-4 mt-4p mb-0">{headerSubText}</h2>}
        </Box>
      </StackView>
      <div className={childrenClassName || "d-f ai-c"}>{children}</div>
    </header>
  )
}

SectionHeading.propTypes = {
  headerText: PropTypes.node,
  headerSubText: PropTypes.node,
  children: PropTypes.node,
  childrenClassName: PropTypes.string,
  headerActions: PropTypes.arrayOf(
    PropTypes.shape({
      onClick: PropTypes.func,
      linkTo: PropTypes.string,
      text: PropTypes.string
    })
  ),
  className: PropTypes.string,
  style: PropTypes.shape({}),
  headerTextStyle: PropTypes.shape({})
}

export default SectionHeading
